export const generateMatrix = matrix => matrix.map(m => ({
  name: m.name,
  namePretext: m.namePretext,
  icon: m.icon,
  rightResultRow: false,
  inputResultRow: '',
  matrix: m.matrix.map(item => ({
    val: item === '?' ? 0 : item,
    icon: item === '?' ? 'help' : String(item),
    activateInput: false,
    input: '',
    id: Math.random().toString(36).slice(2),
    right: false,
    inputResultCol: '',
    rightResultCol: false,
    question: item === '?',
    questionActivate: false,
    answer: null,
  })),
}))
